<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['TIPO', 'EVENTO', 'DESLOCAMENTO', 'DESPESA', 'AGENDAMENTO','CONTATO', 'CONTATO POSITIVO', 'AÇÕES']"
            :showNew="true"
            :showSearch="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ||  obj.inative === null ? 0 : 1" :value="obj.tipoEventoDTO ? obj.tipoEventoDTO.nome.toUpperCase() : ''" />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ||  obj.inative === null ? 0 : 1" :value="obj.nome ? obj.nome.toUpperCase() : ''" />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ||  obj.inative === null ? 0 : 1" :value="obj.deslocamento ? 'SIM' : 'NÃO'" />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ||  obj.inative === null ? 0 : 1" :value="obj.despesa ? 'SIM' : 'NÃO'" />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ||  obj.inative === null ? 0 : 1" :value="obj.agendamento ? 'SIM' : 'NÃO'" />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ||  obj.inative === null ? 0 : 1" :value="obj.contato ? 'SIM' : 'NÃO'" />
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ||  obj.inative === null ? 0 : 1" :value="obj.contatoPositivo ? 'SIM' : 'NÃO'" />
        <td class="text-center">
          <div v-if="obj.inative || obj.inative === null">
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i
                    class="fa fa-lock-open text-secundary icone-grid"
                    style="color: black;"
                    :title="$lang.EventoConfig.UnlockEventToolTip"
                ></i>
              </template>
              <b-dropdown-header><strong>{{ $lang.EventoConfig.ConfirmUnlockEvent }}</strong></b-dropdown-header>
              <b-dropdown-item
                  href="javascript:void(0);"
                  v-on:click="changeGroupStatus(obj, 'false')"
              >
                {{ $lang.Common.Yes }}
              </b-dropdown-item>
              <b-dropdown-item
                  href="javascript:void(0);"
              >
                {{ $lang.Common.No }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div v-else>
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i
                    class="fa fa-ban text-secundary icone-grid"
                    style="color: red;"
                    :title="$lang.EventoConfig.BlockEventToolTip"
                ></i>
              </template>
              <b-dropdown-header>
                <strong>{{ $lang.EventoConfig.ConfirmBlockEvent }}</strong>
              </b-dropdown-header>
              <b-dropdown-item
                  href="javascript:void(0);"
                  v-on:click="changeGroupStatus(obj, 'true')"
              >
                {{ $lang.Common.Yes }}
              </b-dropdown-item>
              <b-dropdown-item
                  href="javascript:void(0);"
              >
                {{ $lang.Common.No }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </td>
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span></button>
      </div>
    </div>
    <SidebarSearch @search="onSearch" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import EventRepository from '@/shared/http/repositories/configurations/event.js'
import {advancedOnException} from '../../../../../../components/tools/Utils'
import SidebarSearch from '@/views/private/configurations/events/components/search/SidebarFUPEvento.vue'

export default {
  name: 'EventList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  components: {
    SidebarSearch
  },
  methods: {
    onNew () {
      this.$emit('New')
    },
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    onLoadAll () {
      loading.push()
      if (this.filters && this.filters.nome) {
        EventRepository.Search(this.filters.nome, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        EventRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      EventRepository.Delete(obj.id)
        .then(this.onResult)
        .catch(this.onException)
    },
    changeGroupStatus (obj, status) {
      loading.push()
      let data = {
        inative: status
      }
      EventRepository.ChangeStatus(obj.id, data)
        .then(() => {
          this.onLoadAll()
          loading.pop()
        })
        .catch(e => advancedOnException(e, this.$lang))
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/events/components/list/eventlist.vue